import React from "react"
import { Box } from "@mui/material"
import { visuallyHidden } from "@mui/utils"

type Props = {
  message?: string
  // a11y: assertive (role="alert") interrupts and is spoken even when the region is
  // inside a just-opened MUI Dialog. Use it for launch confirmations rendered inside
  // a dialog, where the app-root polite region is aria-hidden by the focus trap.
  // Default is polite (role="status") for the app-wide loading region.
  assertive?: boolean
}

// a11y: a hidden live region. AnnounceProvider renders one polite instance for
// app-wide loading status. Render this inline only where the app-root region can't
// be reached — inside a MUI Dialog, which aria-hides everything outside it — passing
// `assertive` so it still announces.
const ScreenReaderAnnouncement: React.FC<Props> = ({
  message = "",
  assertive = false
}) => (
  <Box
    role={assertive ? "alert" : "status"}
    aria-live={assertive ? "assertive" : "polite"}
    aria-atomic="true"
    sx={visuallyHidden}
  >
    {message}
  </Box>
)

export default ScreenReaderAnnouncement
